import apiInternal from './servers/apiInternal';

export interface Credentials {
  arn?: string;
  codigoCredentialOrgaoSistema?: string;
  login?: string;
  sistema?: string;
}

export interface CreateDemandMethod {
  action: 'insert';
  idCallback: string;
  updateFrequency: 'daily' | 'never';
  values: string[];
  credentials?: Credentials;
  urlCallback?: string;
}

export interface CreateDemandParams {
  environment: 'saj' | 'projuris' | 'peticiona';
  idArtifact?: number;
  method: CreateDemandMethod;
  urlCallback?: string;
}

export interface CreateDemandResponse {
  success: boolean;
  idDemanda?: string;
  message?: string;
  status?: string;
  data?: any;
}

const datateamCreate = {
  create: async (params: CreateDemandParams): Promise<CreateDemandResponse> => {
    const response = await apiInternal.post('/datateam/novo', params);
    return response.data;
  },
};

export default datateamCreate;
